// Default error
export const DEFAULT_ERROR = 'Notifications/Landlord/DefaultError';

// Fast payments
export const FAST_PAYMENTS_BANNER = 'Notifications/Landlord/FastPaymentsBanner';

// Onboarding flow
export const MOVE_IN_COSTS_SETTINGS_UPDATED = 'Notifications/Landlord/MoveInCostsSettingsUpdated';
export const CONTINUE_PAYMENT_SETUP = 'Notifications/Landlord/ContinuePaymentSetup';
export const PAYMENT_SETTINGS_UPDATED = 'Notifications/Landlord/PaymentSettingsUpdated';
export const PAYMENT_SETTINGS_COMPLETE = 'Notifications/Landlord/PaymentSettingsComplete';
export const ACCOUNT_LINK_SUCCESS = 'Notifications/Landlord/AccountLinkSuccess';
export const DEPOSIT_ACCOUNT_SET = 'Notifications/Landlord/DepositAccountSet';
export const DEPOSIT_ACCOUNT_UPDATED = 'Notifications/Landlord/DepositAccountUpdated';
export const INVALID_ACCOUNT_INFO = 'Notifications/Landlord/InvalidAccountInfo';
export const TENANT_INFO_UPDATED = 'Notifications/Landlord/TenantInfoUpdated';
export const ID_VERIFICATION_UPDATED = 'Notifications/Landlord/IdVerificationUpdated';
export const TAX_ID_ERROR = 'Notifications/Landlord/TaxIdError';
export const PHONE_VERIFICATION_SEND_ERROR = 'Notifications/Landlord/PhoneVerificationSendError';
export const ONBOARDING_COMPLETE = 'Notifications/Landlord/OnboardingComplete';

// Invite renter
export const INVITE_RENTER_SUCCESS = 'Notifications/Landlord/InviteRenterSuccess';
export const INVITE_NEW_RENTER_SUCCESS = 'Notifications/Landlord/InviteNewRenterSuccess';
export const INVITE_NEW_RENTER = 'Notifications/Landlord/InviteNewRenter';

// Emergency ID verification
export const EMERGENCY_VERIFICATION_NEEDED = 'Notifications/Landlord/EmergencyVerificationNeeded';
export const EMERGENCY_VERIFICATION_SUBMITTED = 'Notifications/Landlord/EmergencyVerificationSubmitted';

// Additional ID verification
export const HOSTED_ONBOARDING_COMPLETED = 'Notifications/Landlord/HostedOnboardingCompleted';
export const HOSTED_ONBOARDING_REQUIRED = 'Notifications/Landlord/HostedOnboardingRequired';

// Rent term change
export const PAYMENT_LENGTH_UPDATED = 'Notifications/Landlord/PaymentLengthUpdated';
export const SWITCH_TO_M2M = 'Notifications/Landlord/SwitchToM2M';
export const STOP_PAYMENTS_SUCCESS = 'Notifications/Landlord/StopPaymentsSuccess';

// Rent amount change
export const RENT_AMOUNT_UPDATE_SUCCESS = 'Notifications/Landlord/RentAmountUpdateSuccess';
export const RENT_AMOUNT_UPDATE_FAIL = 'Notifications/Landlord/RentAmountUpdateFail';
export const RENT_AMOUNT_UPDATE_CANCEL_SUCCESS = 'Notifications/Landlord/RentAmountUpdateCancelled';

// One time payment request
export const ONE_TIME_PAYMENT_REQUEST_SUCCESS = 'Notifications/Landlord/OneTimePaymentRequestSuccess';
export const ONE_TIME_PAYMENT_CANCEL_SUCCESS = 'Notifications/Landlord/OneTimePaymentCancelSuccess';

// Payment Plan request
export const PAYMENT_PLAN_REQUEST_SUCCESS = 'Notifications/Landlord/PaymentPlanRequestSuccess';
export const PAYMENT_PLAN_CANCEL_SUCCESS = 'Notifications/Landlord/PaymentPlanCancelSuccess';

// Move In Costs request
export const MOVE_IN_COSTS_REQUEST_SUCCESS = 'Notifications/Landlord/MoveInCostsRequestSuccess';
export const MOVE_IN_COSTS_CANCEL_SUCCESS = 'Notifications/Landlord/MoveInCostsCancelSuccess';

// Edit tenant info
export const TENANT_INFO_UPDATE_FAIL = 'Notifications/Landlord/TenantInfoUpdateFail';

// Edit Stripe Contact info
export const STRIPE_CONTACT_INFO_UPDATE = 'Notifications/Landlord/StripeContactInfoUpdateSuccess';

// Remind renter
export const REMIND_RENTER_SUCCESS = 'Notifications/Landlord/RemindRenterSuccess';

export const IN_BETWEEN_TERMS = 'Notifications/Landlord/InBetweenTerms';

// Address Verification
export const ADDRESS_VERIFICATION_ERROR = 'Notifications/Landlord/AddressVerificationError';

// Rental Protection Banners
export const RENTAL_PROTECTION_FIRST_RENT_PAYMENT_FAILED =
  'Notifications/Landlord/RentalProtectionFirstRentPaymentFailed';
export const RENTAL_PROTECTION_LATEST_RENT_PAYMENT_FAILED =
  'Notifications/Landlord/RentalProtectionLatestRentPaymentFailed';
export const RENTAL_PROTECTION_COVERAGE_REQUEST_NOT_SIGNED =
  'Notifications/Landlord/RentalProtectionCoverageRequestNotSigned';
export const RENTAL_PROTECTION_POLICY_PENDING = 'Notifications/Landlord/RentalProtectionPolicyPending';
export const COVERAGE_REQUEST_ERROR = 'Notifications/Landlord/CoverageRequestError';

// Payment Plan Missed Rent Banner
export const RENTAL_PROTECTION_MISSED_RENT_PAYMENT_BANNER = 'Notifications/Landlord/RentalProtectionMissedRentPayment';
